import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Twitter, Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8 border-b border-slate-800 pb-12">
        <div className="lg:col-span-2">
          <Link to="/" className="flex items-center space-x-2 mb-6">
            <div className="bg-blue-700 text-white p-1.5 rounded">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/>
                <path d="m9 12 2 2 4-4"/>
              </svg>
            </div>
            <span className="text-2xl font-black tracking-tighter text-white">ROS<span className="text-blue-500">TECH</span></span>
          </Link>
          <p className="text-slate-400 mb-8 max-w-sm leading-relaxed">
            O software nº 1 para oficinas mecânicas e autopeças. Revolucione sua gestão com ERP, CRM, PDV e controle de estoque integrados em uma plataforma robusta e inteligente.
          </p>
          <div className="flex space-x-4">
            <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-700 hover:text-white transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-700 hover:text-white transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-700 hover:text-white transition-colors">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-700 hover:text-white transition-colors">
              <Twitter className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-blue-500 font-bold text-xs mb-6 tracking-widest uppercase">Produto</h3>
          <ul className="space-y-4">
            <li><Link to="/erp" className="hover:text-white transition-colors">ERP Completo</Link></li>
            <li><Link to="/crm" className="hover:text-white transition-colors">CRM Automotivo</Link></li>
            <li><Link to="/pdv" className="hover:text-white transition-colors">PDV Integrado</Link></li>
            <li><Link to="/estoque" className="hover:text-white transition-colors">Controle de Estoque</Link></li>
            <li><Link to="/agendamento" className="hover:text-white transition-colors">Agendamento Online</Link></li>
            <li><Link to="/fiscal" className="hover:text-white transition-colors">Módulo Fiscal (NFe/NFCe)</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-blue-500 font-bold text-xs mb-6 tracking-widest uppercase">Institucional</h3>
          <ul className="space-y-4">
            <li><Link to="/sobre" className="hover:text-white transition-colors">Sobre a Empresa</Link></li>
            <li><Link to="/clientes" className="hover:text-white transition-colors">Casos de Sucesso</Link></li>
            <li><Link to="/blog" className="hover:text-white transition-colors">Blog Automotivo</Link></li>
            <li><Link to="/parceiros" className="hover:text-white transition-colors">Seja um Parceiro</Link></li>
            <li><Link to="/contato" className="hover:text-white transition-colors">Fale Conosco</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-blue-500 font-bold text-xs mb-6 tracking-widest uppercase">Contato</h3>
          <ul className="space-y-4">
            <li className="flex items-start">
              <MapPin className="w-5 h-5 mr-3 mt-0.5 text-blue-500 shrink-0" />
              <span>Av. Paulista, 1000 - Bela Vista<br />São Paulo, SP - 01310-100</span>
            </li>
            <li className="flex items-center">
              <Phone className="w-5 h-5 mr-3 text-blue-500 shrink-0" />
              <span>(24) 9.9281-8632</span>
            </li>
            <li className="flex items-center">
              <Mail className="w-5 h-5 mr-3 text-blue-500 shrink-0" />
              <span>contato@rostech.com.br</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
        <p>&copy; {new Date().getFullYear()} RosTech Sistemas. Todos os direitos reservados.</p>
        <div className="flex space-x-6 mt-4 md:mt-0">
          <Link to="/termos" className="hover:text-slate-300 transition-colors">Termos de Uso</Link>
          <Link to="/privacidade" className="hover:text-slate-300 transition-colors">Política de Privacidade</Link>
        </div>
      </div>
    </footer>
  );
};
